import { Link, useLocation } from 'react-router-dom';
import { Home, Scissors, Calendar, Image, Tag, Phone } from 'lucide-react';

export const MobileNav = ({ onBookingClick }) => {
  const location = useLocation();
  
  const navItems = [
    { path: '/', icon: Home, label: 'Inicio' },
    { path: '/servicios', icon: Scissors, label: 'Servicios' },
    { path: '/agenda', icon: Calendar, label: 'Agenda' },
    { path: '/galeria', icon: Image, label: 'Galería' },
    { path: '/promos', icon: Tag, label: 'Promos' }
  ];

  const isActive = (path) => location.pathname === path;

  const whatsappLink = "https://wa.me/528112345678?text=Hola,%20me%20gustaría%20agendar%20una%20cita";

  return (
    <>
      {/* Floating CTAs - Mobile only */}
      <div className="floating-cta md:hidden">
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp"
          className="whatsapp-btn w-12 h-12 rounded-full flex items-center justify-center shadow-lg"
        >
          <Phone className="w-5 h-5" />
        </a>
        <button
          onClick={onBookingClick}
          data-testid="floating-booking"
          className="bg-graphite text-cream w-12 h-12 rounded-full flex items-center justify-center shadow-lg hover:bg-graphite/90 transition-colors"
        >
          <Calendar className="w-5 h-5" />
        </button>
      </div>

      {/* Bottom Navigation - Mobile only */}
      <nav className="bottom-nav md:hidden" data-testid="mobile-bottom-nav">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`bottom-nav-${item.label.toLowerCase()}`}
              className={`flex flex-col items-center gap-1 px-3 py-1 ${
                isActive(item.path) ? 'text-copper' : 'text-graphite/50'
              }`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </>
  );
};

export default MobileNav;
